import BlogEntryHero from './BlogEntryHero';

export default BlogEntryHero;
